import { default as BtnNormal } from './BtnNormal';

const EXPORT = {
  BtnNormal,
};

export default EXPORT;
